import { gql } from "@apollo/client"

const GET_REPORT_EVENT_ATTENDANCE_XLS_DOWNLOAD_LINK = gql`
  query ($event_id: ID!) {
    reportEventAttendanceXls(event_id: $event_id) {
      filename
      type
      url
    }
  }
`

export { GET_REPORT_EVENT_ATTENDANCE_XLS_DOWNLOAD_LINK }
